import PropTypes from "prop-types"
//import Vimeo from "@u-wave/react-vimeo" // Seems to be loading each video twice, causing issues.
import React, { useRef, useEffect } from "react"

export function AddVimeoScript(element) {
  const vimeo = document.createElement("script")
  document.getElementsByTagName("head")[0].appendChild(vimeo)
  vimeo.src = `//player.vimeo.com/api/player.js`
  vimeo.async = true
}

function Video(props) {
  const videoRef = useRef(null)
  return (
    <iframe
      src={`https://player.vimeo.com/video/${props.id}?h=${props.h}&speed=0&muted=1&autoplay=1&controls=0&loop=1&background=1&quality=720p&app_id=122963&texttrack=undefined`}
      frameBorder={"0"}
      allow={"autoplay; fullscreen; picture-in-picture"}
      title={""}
      data-ready={"true"}
      loading={"lazy"}
      className={"lazyload "}
      ref={videoRef}
    ></iframe>
  )
}

Video.propTypes = {
  id: PropTypes.string,
  h: PropTypes.string,
}

export default Video
